define((require) => {
    "use strict";

    var PSDImportView = require("ui/settings/psdImport/PSDImportView"),
        Marionette    = require("marionette");

    return Marionette.Controller.extend({

        showPSDImport: function() {
            this.options.region.show(new PSDImportView());
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/psdImport/PSDImportController.js